import React from 'react';
const CircularLoader = () => {
    return (
        <div className="flex justify-center items-center h-full">
            <div className="rounded-full border-t-4 border-b-4 border-gray-400 h-12 w-12 animate-spin"></div>
        </div>
    );
};

export default CircularLoader;